import { Grid, Tooltip} from "@mui/material";

export function getProductStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'You must enter Party Name',
            required:true,
            fieldtype:'string'
        },
        title:{
            name:'title',
            label:'Product Title',
            value:'',
            error:false,
            errorMessage:'You must enter Product Title',
            required:true,
            fieldtype:'string'
        },
        partyid:{
            name:'partyid',
            label:'Party ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        statusid:{
            name:'statusid',
            label:'Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        designstatus:{
            name:'designstatus',
            label:'Design Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'list'
        },
        formid:{
            name:'formid',
            label:'Form Id',
            value:'',
            error:false,
            errorMessage:'You must enter Form Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        batchsize:{
            name:'batchsize',
            label:'Batch Size',
            value:'',
            error:false,
            errorMessage:'You must enter Batch Size',
            required:true,
            fieldtype:'number'
        },
        executivename:{
            name:'executivename',
            label:'Executive Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'list'
        },
        foillabel:{
            name:'foillabel',
            label:'FoilLabel',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        packaging:{
            name:'packaging',
            label:'Packaging',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rate:{
            name:'rate',
            label:'Rate',
            value:'',
            error:false,
            errorMessage:'You must enter Rate',
            required:true,
            fieldtype:'double'
        },
        mrp:{
            name:'mrp',
            label:'MRP',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        expirydate:{
            name:'expirydate',
            label:'Expiry Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        remarks:{
            name:'remarks',
            label:'Remarks',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        cr_cash:{
            name:'cr_cash',
            label:'CR_CASH',
            value:'',
            error:false,
            errorMessage:'You must enter CR_CASH',
            required:true,
            fieldtype:'list'
        },
        podate:{
            name:'podate',
            label:'PO Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        dispatchedsize:{
            name:'dispatchedsize',
            label:'Dispatched Size',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        packagingtypeid:{
            name:'packagingtypeid',
            label:'Packaging Type Id',
            value:'',
            error:false,
            errorMessage:'You must enter Packaging Type Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        packagingremarks:{
            name:'packagingremarks',
            label:'Packaging Remarks',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        amount:{
            name:'amount',
            label:'Amount',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        dispatchdate:{
            name:'dispatchdate',
            label:'Dispatch Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        orderid:{
            name:'orderid',
            label:'Order ID',
            value:'',
            error:false,
            errorMessage:'You must enter Order ID',
            required:true,
            fieldtype:'ID'
        },
        batchpackaging:{
            name:'batchpackaging',
            label:'Batch Packaging',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'list'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        designvendorname:{
            name:'designvendorname',
            label:'Design Vendor Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        designdispatched:{
            name:'designdispatched',
            label:'Design Dispatched',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        shapeid:{
            name:'shapeid',
            label:'Shape Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        shapename:{
            name:'shapename',
            label:'Shape Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        formname:{
            name:'formname',
            label:'Form Name',
            value:'',
            error:false,
            errorMessage:'You must enter Form Name',
            required:true,
            fieldtype:'string'
        },
        statusname:{
            name:'statusname',
            label:'Status Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        packagingtypename:{
            name:'packagingtypename',
            label:'Packaging Type Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rmstatus:{
            name:'rmstatus',
            label:'RM Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        packagingsize1id:{
            name:'packagingsize1id',
            label:'Packaging Size 1 Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        packagingsize1name:{
            name:'packagingsize1name',
            label:'Packaging Size 1 Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        packagingsize2id:{
            name:'packagingsize2id',
            label:'Packaging Size 2 Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        packagingsize2name:{
            name:'packagingsize2name',
            label:'Packaging Size 2 Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        setid:{
            name:'setid',
            label:'Set Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        setname:{
            name:'setname',
            label:'Set Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        ctid:{
            name:'ctid',
            label:'ctid',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        qareferbackreason:{
            name:'qareferbackreason',
            label:'QA Refer Back Reason',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        designstatusqa:{
            name:'designstatusqa',
            label:'Design Status QA',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        rmorderedon:{
            name:'rmorderedon',
            label:'RM Ordered On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        rmreceivedon:{
            name:'rmreceivedon',
            label:'RM Received On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        designorderedon:{
            name:'designorderedon',
            label:'Design Ordered On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        designreceivedon:{
            name:'designreceivedon',
            label:'Design Received On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        brandname:{
            name:'brandname',
            label:'Brand Name',
            value:'',
            error:false,
            errorMessage:'You must enter Brand Name',
            required:true,
            fieldtype:'string'
        },
        repeatorder:{
            name:'repeatorder',
            label:'Repeat Order',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        designapprovaldate:{
            name:'designapprovaldate',
            label:'Design Approval Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        qadesignapprovaldate:{
            name:'qadesignapprovaldate',
            label:'QA Design Approval Date ',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        qacompapprovaldate:{
            name:'qacompapprovaldate',
            label:'QA Comp Approval Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        batchnumber:{
            name:'batchnumber',
            label:'Batch Number',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        pmorderid:{
            name:'pmorderid',
            label:'PM Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        rmorderid:{
            name:'rmorderid',
            label:'RM Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        gstid:{
            name:'gstid',
            label:'GST Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        gstname:{
            name:'gstname',
            label:'GST Name',
            value:'',
            error:false,
            errorMessage:'You must enter GST Name',
            required:true,
            fieldtype:'string'
        },
        inventorycharges:{
            name:'inventorycharges',
            label:'Inventory Charges',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        cylindercharges:{
            name:'cylindercharges',
            label:'Cylinder Charges',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        repeatproduct:{
            name:'repeatproduct',
            label:'Repeat Product',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        repeatproductid:{
            name:'repeatproductid',
            label:'Repeat Product Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        advance:{
            name:'advance',
            label:'advance',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        total:{
            name:'total',
            label:'total',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        totalwithgst:{
            name:'totalwithgst',
            label:'totalwithgst',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        assetname:{
            name:'assetname',
            label:'Asset Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        assetpath:{
            name:'assetpath',
            label:'Asset Path',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        assetid:{
            name:'assetid',
            label:'Asset Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        pmreceivedon:{
            name:'pmreceivedon',
            label:'PM Received On',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        qaassetid:{
            name:'qaassetid',
            label:'QA Asset Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        qaassetname:{
            name:'qaassetname',
            label:'QA Asset Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        qaassetpath:{
            name:'qaassetpath',
            label:'QA Asset Path',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        comptype:{
            name:'comptype',
            label:'Comp Type',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        packagingtext:{
            name:'packagingtext',
            label:'Packaging Text',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        liquidcolor:{
            name:'liquidcolor',
            label:'Liquid Color',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        manufdate:{
            name:'manufdate',
            label:'Manuf Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        overallstatusid:{
            name:'overallstatusid',
            label:'Overall Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        approvaldate:{
            name:'approvaldate',
            label:'Approval Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        submissiondate:{
            name:'submissiondate',
            label:'Submission Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        deliverydate:{
            name:'deliverydate',
            label:'Delivery Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        cancelleddate:{
            name:'cancelleddate',
            label:'Cancelled Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        mrptext:{
            name:'mrptext',
            label:'MRP Text',
            value:'',
            error:false,
            errorMessage:'You must enter MRP Text',
            required:true,
            fieldtype:'string'
        },
        reasondate:{
            name:'reasondate',
            label:'Reason Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        reason:{
            name:'reason',
            label:'Reason',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        monthtagid:{
            name:'monthtagid',
            label:'Month Tag Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        prestatusid:{
            name:'prestatusid',
            label:'Pre Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        biltyid:{
            name:'biltyid',
            label:'Bilty Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        executiveid:{
            name:'executiveid',
            label:'Executive Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'statusname', headerName: 'Status Name', width:50 },
        { field: 'rmstatus', headerName: 'RM Status', width:150 },
        { field: 'brandname', headerName: 'Brand Name', width:150 },
        { field: 'repeatorder', headerName: 'Repeat Order', width:150 },
        { field: 'designapprovaldate', headerName: 'Design Approval Date', width:150 },
        { field: 'qadesignapprovaldate', headerName: 'QA Design Approval Date ', width:150 },
        { field: 'qacompapprovaldate', headerName: 'QA Comp Approval Date', width:150 },
        { field: 'batchnumber', headerName: 'Batch Number', width:150 },
        { field: 'pmorderid', headerName: 'PM Order Id', width:150 },
        { field: 'rmorderid', headerName: 'RM Order Id', width:150 },
        { field: 'gstid', headerName: 'GST Id', width:150 },
        { field: 'gstname', headerName: 'GST Name', width:150 },
        { field: 'inventorycharges', headerName: 'Inventory Charges', width:150 },
        { field: 'cylindercharges', headerName: 'Cylinder Charges', width:150 },
        { field: 'repeatproduct', headerName: 'Repeat Product', width:150 },
        { field: 'repeatproductid', headerName: 'Repeat Product Id', width:150 },
        { field: 'advance', headerName: 'advance', width:150 },
        { field: 'total', headerName: 'total', width:150 },
        { field: 'totalwithgst', headerName: 'totalwithgst', width:150 },
        { field: 'assetname', headerName: 'Asset Name', width:150 },
        { field: 'assetpath', headerName: 'Asset Path', width:150 },
        { field: 'assetid', headerName: 'Asset Id', width:150 },
        { field: 'pmreceivedon', headerName: 'PM Received On', width:150 },
        { field: 'qaassetid', headerName: 'QA Asset Id', width:150 },
        { field: 'qaassetname', headerName: 'QA Asset Name', width:150 },
        { field: 'qaassetpath', headerName: 'QA Asset Path', width:150 },
        { field: 'packagingtext', headerName: 'Packaging Text', width:150 },
        { field: 'liquidcolor', headerName: 'Liquid Color', width:150 },
        { field: 'manufdate', headerName: 'Manuf Date', width:150 },
        { field: 'overallstatusid', headerName: 'Overall Status Id', width:150 },
        { field: 'approvaldate', headerName: 'Approval Date', width:150 },
        { field: 'submissiondate', headerName: 'Submission Date', width:150 },
        { field: 'deliverydate', headerName: 'Delivery Date', width:150 },
        { field: 'cancelleddate', headerName: 'Cancelled Date', width:150 },
        { field: 'mrptext', headerName: 'MRP Text', width:150 },
        { field: 'reasondate', headerName: 'Reason Date', width:150 },
        { field: 'reason', headerName: 'Reason', width:150 },
        { field: 'monthtagid', headerName: 'Month Tag Id', width:150 },
        { field: 'prestatusid', headerName: 'Pre Status Id', width:150 },
        { field: 'biltyid', headerName: 'Bilty Id', width:150 },
        { field: 'executiveid', headerName: 'Executive Id', width:150 },
        { field: 'orderid', headerName: 'Order ID', width:100 },
        { field: 'title', headerName: 'Product Title', width:130 },
        { field: 'partyname', headerName: 'Party Name', width:150 },
        { field: 'amount', headerName: 'Amount', width:100 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['designvendorname']:{
          ...formValues['designvendorname'],
          value:data.designvendorname,
        },['designdispatched']:{
          ...formValues['designdispatched'],
          value:data.designdispatched,
        },['shapeid']:{
          ...formValues['shapeid'],
          value:data.shapeid,
        },['shapename']:{
          ...formValues['shapename'],
          value:data.shapename,
        },['formname']:{
          ...formValues['formname'],
          value:data.formname,
        },['statusname']:{
          ...formValues['statusname'],
          value:data.statusname,
        },['packagingtypename']:{
          ...formValues['packagingtypename'],
          value:data.packagingtypename,
        },['rmstatus']:{
          ...formValues['rmstatus'],
          value:data.rmstatus,
        },['packagingsize1id']:{
          ...formValues['packagingsize1id'],
          value:data.packagingsize1id,
        },['packagingsize1name']:{
          ...formValues['packagingsize1name'],
          value:data.packagingsize1name,
        },['packagingsize2id']:{
          ...formValues['packagingsize2id'],
          value:data.packagingsize2id,
        },['packagingsize2name']:{
          ...formValues['packagingsize2name'],
          value:data.packagingsize2name,
        },['setid']:{
          ...formValues['setid'],
          value:data.setid,
        },['setname']:{
          ...formValues['setname'],
          value:data.setname,
        },['ctid']:{
          ...formValues['ctid'],
          value:data.ctid,
        },['qareferbackreason']:{
          ...formValues['qareferbackreason'],
          value:data.qareferbackreason,
        },['designstatusqa']:{
          ...formValues['designstatusqa'],
          value:data.designstatusqa,
        },['rmorderedon']:{
          ...formValues['rmorderedon'],
          value:data.rmorderedon,
        },['rmreceivedon']:{
          ...formValues['rmreceivedon'],
          value:data.rmreceivedon,
        },['designorderedon']:{
          ...formValues['designorderedon'],
          value:data.designorderedon,
        },['designreceivedon']:{
          ...formValues['designreceivedon'],
          value:data.designreceivedon,
        },['brandname']:{
          ...formValues['brandname'],
          value:data.brandname,
        },['repeatorder']:{
          ...formValues['repeatorder'],
          value:data.repeatorder,
        },['designapprovaldate']:{
          ...formValues['designapprovaldate'],
          value:data.designapprovaldate,
        },['qadesignapprovaldate']:{
          ...formValues['qadesignapprovaldate'],
          value:data.qadesignapprovaldate,
        },['qacompapprovaldate']:{
          ...formValues['qacompapprovaldate'],
          value:data.qacompapprovaldate,
        },['batchnumber']:{
          ...formValues['batchnumber'],
          value:data.batchnumber,
        },['pmorderid']:{
          ...formValues['pmorderid'],
          value:data.pmorderid,
        },['rmorderid']:{
          ...formValues['rmorderid'],
          value:data.rmorderid,
        },['gstid']:{
          ...formValues['gstid'],
          value:data.gstid,
        },['gstname']:{
          ...formValues['gstname'],
          value:data.gstname,
        },['inventorycharges']:{
          ...formValues['inventorycharges'],
          value:data.inventorycharges,
        },['cylindercharges']:{
          ...formValues['cylindercharges'],
          value:data.cylindercharges,
        },['repeatproduct']:{
          ...formValues['repeatproduct'],
          value:data.repeatproduct,
        },['repeatproductid']:{
          ...formValues['repeatproductid'],
          value:data.repeatproductid,
        },['advance']:{
          ...formValues['advance'],
          value:data.advance,
        },['total']:{
          ...formValues['total'],
          value:data.total,
        },['totalwithgst']:{
          ...formValues['totalwithgst'],
          value:data.totalwithgst,
        },['assetname']:{
          ...formValues['assetname'],
          value:data.assetname,
        },['assetpath']:{
          ...formValues['assetpath'],
          value:data.assetpath,
        },['assetid']:{
          ...formValues['assetid'],
          value:data.assetid,
        },['pmreceivedon']:{
          ...formValues['pmreceivedon'],
          value:data.pmreceivedon,
        },['qaassetid']:{
          ...formValues['qaassetid'],
          value:data.qaassetid,
        },['qaassetname']:{
          ...formValues['qaassetname'],
          value:data.qaassetname,
        },['qaassetpath']:{
          ...formValues['qaassetpath'],
          value:data.qaassetpath,
        },['comptype']:{
          ...formValues['comptype'],
          value:data.comptype,
        },['packagingtext']:{
          ...formValues['packagingtext'],
          value:data.packagingtext,
        },['liquidcolor']:{
          ...formValues['liquidcolor'],
          value:data.liquidcolor,
        },['manufdate']:{
          ...formValues['manufdate'],
          value:data.manufdate,
        },['overallstatusid']:{
          ...formValues['overallstatusid'],
          value:data.overallstatusid,
        },['approvaldate']:{
          ...formValues['approvaldate'],
          value:data.approvaldate,
        },['submissiondate']:{
          ...formValues['submissiondate'],
          value:data.submissiondate,
        },['deliverydate']:{
          ...formValues['deliverydate'],
          value:data.deliverydate,
        },['cancelleddate']:{
          ...formValues['cancelleddate'],
          value:data.cancelleddate,
        },['mrptext']:{
          ...formValues['mrptext'],
          value:data.mrptext,
        },['reasondate']:{
          ...formValues['reasondate'],
          value:data.reasondate,
        },['reason']:{
          ...formValues['reason'],
          value:data.reason,
        },['monthtagid']:{
          ...formValues['monthtagid'],
          value:data.monthtagid,
        },['prestatusid']:{
          ...formValues['prestatusid'],
          value:data.prestatusid,
        },['biltyid']:{
          ...formValues['biltyid'],
          value:data.biltyid,
        },['executiveid']:{
          ...formValues['executiveid'],
          value:data.executiveid,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },['partyid']:{
          ...formValues['partyid'],
          value:data.partyid,
        },['statusid']:{
          ...formValues['statusid'],
          value:data.statusid,
        },['designstatus']:{
          ...formValues['designstatus'],
          value:data.designstatus,
        },['formid']:{
          ...formValues['formid'],
          value:data.formid,
        },['batchsize']:{
          ...formValues['batchsize'],
          value:data.batchsize,
        },['executivename']:{
          ...formValues['executivename'],
          value:data.executivename,
        },['foillabel']:{
          ...formValues['foillabel'],
          value:data.foillabel,
        },['packaging']:{
          ...formValues['packaging'],
          value:data.packaging,
        },['rate']:{
          ...formValues['rate'],
          value:data.rate,
        },['mrp']:{
          ...formValues['mrp'],
          value:data.mrp,
        },['expirydate']:{
          ...formValues['expirydate'],
          value:data.expirydate,
        },['remarks']:{
          ...formValues['remarks'],
          value:data.remarks,
        },['cr_cash']:{
          ...formValues['cr_cash'],
          value:data.cr_cash,
        },['podate']:{
          ...formValues['podate'],
          value:data.podate,
        },['dispatchedsize']:{
          ...formValues['dispatchedsize'],
          value:data.dispatchedsize,
        },['packagingtypeid']:{
          ...formValues['packagingtypeid'],
          value:data.packagingtypeid,
        },['packagingremarks']:{
          ...formValues['packagingremarks'],
          value:data.packagingremarks,
        },['amount']:{
          ...formValues['amount'],
          value:data.amount,
        },['dispatchdate']:{
          ...formValues['dispatchdate'],
          value:data.dispatchdate,
        },['batchpackaging']:{
          ...formValues['batchpackaging'],
          value:data.batchpackaging,
        },
      })
}